import { getContract, getOrganization } from '../services/user.util'
import { ContractType } from '../type/security.type'
import { UserType } from '../type/user.type'

// Organization is the same as contract id in Signal
export const useOrganization = (user?: UserType): ContractType | undefined => {
  if (user) {
    return getOrganization(user)
  }
  return undefined
}

export const useContract = (user?: UserType): ContractType | undefined => {
  if (user) {
    return getContract(user)
  }
  return undefined
}
